import React from 'react'
import {PageHeader} from '@/components/molecules'
import PromotionList from '@/features/PromotionList/PromotionList.jsx'


export const PromotionListPage = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title={'Promotions'} />
      </div>
      <PromotionList />
    </div>
  )
}